import React from 'react';
import TipComponent from './TipComponent';

export default function ajaxTipComponent() {
    return OriginComponent => {
        return class AjaxTipComponents extends React.Component {
            constructor(props) {
                super(props);
            }

            //renderTip
            renderTips() {
                return this.props.ajaxTips.map(tipInfo => {
                    return <TipComponent actions={this.props.actions} key={tipInfo.id} id={tipInfo.id} message={tipInfo.message} type={tipInfo.type} />;
                });
            }

            render() {
                return (<OriginComponent {...this.props}>
                    <div className='tips-wrapper'>
                        {this.renderTips()}
                    </div>
                </OriginComponent>);
            }
        };
    };
}



// WEBPACK FOOTER //
// ./src/components/Common/AjaxTipComponent.js